import { request, downloadFile } from '../utils/request'
import { stringify } from '../utils/index'
import { getBaseUrl } from '../config/config_dev'
export default {
  getluxurycerttemplates: (option) => request('v1/luxurycerttemplate/getluxurycerttemplates' + stringify(option), option,), //  证书模板
  addluxurycerttemplate: (option) => request('v1/luxurycerttemplate/addluxurycerttemplate', option), // 新增品牌
  updateluxurycerttemplate: (option) => request('v1/luxurycerttemplate/updateluxurycerttemplate', option), // 修改品牌
  deleteluxurycerttemplate: (option) => request('v1/luxurycerttemplate/deleteluxurycerttemplate' + stringify(option), option), // 删除品牌

  downloadidentificationcert: (option) => downloadFile(getBaseUrl() + 'v1/luxurycert/downloadidentificationcert' + stringify(option), option), // 下载鉴定意见书模板
  updateidentificationcert: (option) => request('v1/luxurycert/updateidentificationcert', option), // 更新鉴定证书

  downloadidentificationcerts: (option) => downloadFile(getBaseUrl() + 'v1/luxurycert/downloadidentificationcerts' + stringify(option), option)
}
